import gql from "graphql-tag";
import LiveEventUniversityFragment from "../../fragments/LiveEventUniversityFragment";

export const openDayQuery = gql`
    query OpenDay($openDayId: String!, $isLoggedIn: Boolean!, $universitySlug: String!) {
        openDay(openDayId: $openDayId) {
            id
            title
            description
            start
            end
            image
            liveEvents {
                id
                slug
                name
                image
                start
                description
                end
                isUserRegistered @include(if: $isLoggedIn)
            }
            externalEvents {
                id
                url
                name
                image
                start
                description
                end
            }
            navigateOpenDays {
                id
                title
                description
                start
                end
                image
            }
            isStaffCarouselEnabled
            isStudentsCarouselEnabled
        }
        university(slug: $universitySlug) {
            ...UniversityFragment
        }
    }
    ${LiveEventUniversityFragment}
`;
